// Centralised brand contact info.
export const PHONE_DISPLAY = "06 9763 6222";
export const PHONE_TEL = "+390697636222"; // E.164
export const PHONE_TEL_HREF = `tel:${PHONE_TEL}`;
export const BRAND_NAME = "Carroattrezzi Roma H24";

// WhatsApp is DISABLED because the primary number (06 97636222) is a
// landline (Rome area code) — WhatsApp does not support fixed-line numbers.
// If a mobile number is provided later, set WHATSAPP_ENABLED = true and
// update WHATSAPP_NUMBER to the E.164 mobile (e.g. "39XXXXXXXXX").
export const WHATSAPP_ENABLED = false;
export const WHATSAPP_NUMBER = ""; // e.g. "39XXXXXXXXX"
export const WHATSAPP_DEFAULT_MSG =
  "Ciao, ho bisogno di un carro attrezzi a Roma. Potete intervenire?";
export const WHATSAPP_HREF = WHATSAPP_ENABLED && WHATSAPP_NUMBER
  ? `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_DEFAULT_MSG)}`
  : PHONE_TEL_HREF; // graceful fallback: any residual WhatsApp link becomes a call.

// Google Business Profile — verified data (updated 2026-08 from live GBP).
export const GBP_CID = "8251669872108359873";
export const GBP_PLACE_URL = `https://www.google.com/maps/place/?cid=${GBP_CID}`;
export const GBP_RATING = 4.9;
export const GBP_REVIEW_COUNT = 11;
